import { ReactComponent as BenchmarkingIcon } from './benchmarking.svg';

export default BenchmarkingIcon;
